import React, {PropTypes} from 'react';
import {FormattedMessage} from 'react-intl';

class FilterGroup extends React.PureComponent {
  static propTypes = {
    listFilters: PropTypes.array,
    filterTitle: PropTypes.string
  };


  render() {
    // render all filters in array
    let filters = this.props.listFilters.map((filter, index) => {
      return (
        <div className="filter-group" key={this.props.filterTitle + '-' + index}>
          {filter}
        </div>
      );
    });

    return (
      <div className={this.props.filterTemplate + ' filter-wrapper'}>
        <FormattedMessage id={"filter-group-" + this.props.filterTitle}>
          {(message) => <h5 className="filter-title">{message}</h5>}
        </FormattedMessage>
        {filters}
      </div>
    );
  }
}

export default FilterGroup;




/** WEBPACK FOOTER **
 ** ./src/components/nav/FilterGroup.js
 **/